export enum FormStep {
    fillingForm = 1,
    formSentMessage = 2,
}
